import React from "react";
import { Drawer } from "antd";
import { useTranslation } from "react-i18next";
import DocumentViewer from "../../Invoice/DocumentViewer";
import { getQueuePreviewViewerProps } from "./documentPreviewUtil";

/**
 * Queue-side invoice preview. The original file is streamed through
 * GET /document/file/:id (cookie-authenticated, assignment-agnostic).
 * Do not call GET /document/:id here — that endpoint is for the editor
 * payload and rejects unassigned claims, which is every manual upload.
 */
export const DocumentPreviewPane = ({
  documentId,
  url,
  fileName,
  active = true,
}) => {
  if (!active) return null;

  return (
    <div className="document-preview-pane">
      <DocumentViewer
        {...getQueuePreviewViewerProps({ documentId, url, fileName })}
        onChange={() => {}}
      />
    </div>
  );
};

/**
 * DocumentPreviewDrawer — expanding sidebar preview of the original invoice
 * document. Works for every document, including ones whose extraction
 * failed and cannot be opened for editing.
 */
const DocumentPreviewDrawer = ({ open, title, url, fileName, documentId, onClose }) => {
  const { t } = useTranslation();

  return (
    <Drawer
      title={title || t("previewDocument")}
      placement="right"
      width="55vw"
      open={open}
      onClose={onClose}
      destroyOnClose
      styles={{ body: { padding: 0, height: "calc(100vh - 55px)" } }}
    >
      <DocumentPreviewPane
        documentId={documentId}
        url={url}
        fileName={fileName || title}
        active={open}
      />
    </Drawer>
  );
};

export default DocumentPreviewDrawer;
